"use client";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useTheme } from "@mui/material/styles";
import { type FC } from "react";

import { RichTooltip } from "~/components/UI/RichTooltip";

const METRICS_TOOLTIP =
  "24H VOL: Total trading volume across all platforms in the last 24 hours. Some platforms may report data with a delay. \n" +
  "\n24H TRANSACTIONS: Total number of trades executed across platforms in the last 24 hours. Polymarket reflects real-time on-chain transactions. Other platforms may be delayed or estimated.\n" +
  "\nOPEN INTEREST: Total value of active positions that have not yet resolved. Currently based on available data from select platforms (e.g., Polymarket). Some platforms, including Kalshi, do not provide open interest.\n" +
  "\nMARKETS ACROSS EVENTS: Markets are individual contracts (e.g., ‘Yes/No’ outcomes), while events group related markets around a single question. Counts include all tracked platforms.\n" +
  "\nAGGREGATED / MATCHED EVENTS:  Events grouped across platforms that represent the same underlying event, allowing side-by-side comparison of odds and activity.\n" +
  "\nPLATFORM COVERAGE:  Number of prediction market platforms currently tracked and aggregated.\n" +
  "\nPOLYMARKET VS. KALSHI: Share of total trading volume by platform. Calculated using comparable time windows to ensure accuracy across data sources.";

export const GlobalMetricsTooltip: FC = () => {
  const theme = useTheme();

  return (
    <RichTooltip title={METRICS_TOOLTIP} maxWidth={500}>
      <InfoOutlinedIcon
        style={{ width: 18 }}
        htmlColor={theme.palette.primary.contrastText}
      />
    </RichTooltip>
  )
}